import { render, staticRenderFns } from "./AppointmentUpdateMultiple.vue?vue&type=template&id=08f13d2e&"
import script from "./AppointmentUpdateMultiple.vue?vue&type=script&lang=js&"
export * from "./AppointmentUpdateMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports